import React from "react";

const ContentQuoteBlock = ({ block }) => {
    if (!block?.quote) {
        return null;
    }

    return (
        <figure className="content-quote">
            {block.eyebrow && (
                <div className="content-quote__eyebrow">{block.eyebrow}</div>
            )}
            <div className="content-quote__box">
                <blockquote
                    className="content-quote__text"
                    dangerouslySetInnerHTML={{ __html: block.quote }}
                />
                {(block.author || block.role) && (
                    <figcaption className="content-quote__caption">
                        {block.author && (
                            <strong className="content-quote__author">
                                {block.author}
                            </strong>
                        )}
                        {block.role && (
                            <span className="content-quote__role">
                                {block.role}
                            </span>
                        )}
                    </figcaption>
                )}
            </div>
        </figure>
    );
};

export default ContentQuoteBlock;
